import { getUniqueID } from '@/utils/helpers/FormBuilderHelper';

export const exportFormSchema = ({ flowVersion = 3, task = {}, workflowName = '' }) => {
  const data = {
    version: flowVersion,
    caption: task?.caption,
    props: task?.props || [],
  };

  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const uniqueName =
    workflowName?.trim() !== '' ? workflowName.trim() : `elements_${getUniqueID()}`;
  link.download = `${uniqueName}.json`;
  link.click();
  URL.revokeObjectURL(url);
};
